<div class="grid">
  <div class="col-12">
    <div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <h1 class="titulo-pagina">{{ 'AGENDA.LBL_AGENDA' | translate }}</h1>
        </div>
      </div>
      <div class="grid contenedor-filtros">
        <div class="col-12 md:col-12 lg:col-12">
          <form [formGroup]="formulario" (ngSubmit)="filter()">
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label for="estructurasFisicas">{{ 'AGENDA.LBL_ESTRUCTURAFISICA' | translate}}</label>
                  <p-dropdown disableTab  id="estructurasFisicas" [options]="estructurasFisicas"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              formControlName="idEstructuraFisica" filter="filter"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label for="ejecutivo">{{ 'AGENDA.LBL_EJECUTIVO' | translate}}</label>
                  <input id="ejecutivo" type="text" pInputText size="40" (keyup.enter)="filterEnter()"
                         placeholder="{{ 'AGENDA.LBL_EJECUTIVO' | translate }}" sin-caracteres-especiales-reactive
                         formControlName="ejecutivo">
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label for="zona">{{ 'AGENDA.LBL_ZONA' | translate}}</label>
                  <input id="zona" type="text" pInputText size="40" (keyup.enter)="filterEnter()"
                         placeholder="{{ 'AGENDA.LBL_ZONA' | translate }}" sin-caracteres-especiales-reactive
                         formControlName="zona">
                </div>
              </div>
            </div>

            <div class="grid form-footer-buttons" *ngIf="!carBusqueda">
              <div class="form-group col-12 gap-2">
                <button type="button" pButton class="p-button-secondary" icon="fa fa-eraser"
                        (click)="limpiar()"
                        label="{{ 'AGENDA.BTN_LIMPIAR' | translate}}"></button>
                <button type="submit" pButton class="p-button-success" icon="fa fa-filter"
                        label="{{ 'AGENDA.BTN_FILTRAR' | translate}}"></button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="carBusqueda" #dt
                   [lazy]="true"
                   [value]="zonas"
                   [totalRecords]="rowsCount"
                   (onLazyLoad)="filter($event)"
                   selectionMode="single" dataKey="idZona"
                   [paginator]="true" [rows]="rowsPerPage"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.estructura}}</td>
                <td>{{row.zona}}</td>
                <td>{{row.nombreEjecutivo}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorPrincipal" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorSecundario" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-inputSwitch [(ngModel)]="row.indicadorAgenda" name="nom{{row.idZona}}" (onChange)="cambiarProspectar(row)" [disabled]="row.indicadorLibre || row.indicadorSinRuta"></p-inputSwitch>
                </td>
                <td class="text-center">
                  <p-inputSwitch [(ngModel)]="row.indicadorLibre" name="nom{{row.idZona}}" (onChange)="cambiarProspectar(row)" [disabled]="row.indicadorAgenda || row.indicadorSinRuta"></p-inputSwitch>
                </td>
                <td class="text-center">
                  <p-inputSwitch [(ngModel)]="row.indicadorSinRuta" name="nom{{row.idZona}}" (onChange)="cambiarProspectar(row)" [disabled]="row.indicadorAgenda || row.indicadorLibre"></p-inputSwitch>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorLunes" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorMartes" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorMiercoles" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorJueves" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorViernes" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorSabado" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorDomingo" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                            title="{{'AGENDA.BTN_VISUALIZARAGENDA' | translate}}" pButton *ngIf="menu.ver"
                            (click)="view(row)"></button>
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-calendar"
                            data-toggle="tooltip" *ngIf="menu.editar"
                            title="{{'AGENDA.BTN_CREARAGENDA' | translate}}" pButton
                            (click)="update(row)"></button>

                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
